import request from "@/utils/request";

/**
 * @Author: wulizhou
 * @Description:  详情天降红包活动
 * @Date: 2023.4.12
 **/


export function getCouponByRedPacketRain(query) {
  return request({
    url: '/?m=Activity&a=redPacketRain',
    method: 'get',
    params: query
  })
}


export function checkCouponIsReceiveByRedPacketRain(query) {
  return request({
    url: '/?m=Activity&a=redPacketRule',
    method: 'get',
    params: query
  })
}
